export const ERROR_MESSAGE_REQUIRED = 'This is required';
export const ERROR_MESSAGE_EMAIL_FORMAT = 'Email format is invalid';
